<template>
    <section>
        <!--工具条-->
        <!--<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;margin-bottom:22px;">
            <el-select v-model="SelCouponId" filterable placeholder="请选择优惠券类型" style="width: 180px">
                <el-option :key="0" :value="0" :label="'全部'"></el-option>
                <el-option v-for="item in couponList"
                           :key="item.Id"
                           :label="item.Name"
                           :value="item.Id">
                    <span style="float: left">{{ item.Name }}</span>
                </el-option>
            </el-select>
            <el-select v-model="SelStatus" filterable placeholder="请选择优惠券状态" style="width: 110px">
                <el-option label="全部" value="-1"></el-option>
                <el-option label="未使用" value="0"></el-option>
                <el-option label="已使用" value="1"></el-option>
                <el-option label="已过期" value="2"></el-option>
            </el-select>
            <el-input v-model="SelUserName" placeholder="会员Id" style="width:200px;margin-left:10px;"></el-input>
            <el-input v-model="searchVal" placeholder="关键字" style="width:300px;margin-left:10px;"></el-input>
            <el-button type="primary" @click="handleSearch()">查询</el-button>
            <!--<el-button type="primary" @click="handleAdd()" v-if="isAdd">新增</el-button>-->
        </el-col>


        <!--列表-->
        <el-table :data="datas"
                  highlight-current-row
                  v-loading="listLoading"
                  @selection-change="selsChange"
                  @current-change="selectCurrentRow"
                  row-key="Id"
                  border
                  lazy
                  style="width: 99%;"
                  ref="table">
            <el-table-column type="index" :index="indexMethod" label="序号" width="50" fixed></el-table-column>

            <el-table-column prop="UserId" label="会员Id" width="" sortable>
            </el-table-column>
            <el-table-column prop="NickName" label="会员昵称" width="" sortable>
            </el-table-column>
            <el-table-column prop="Name" label="充值类型" sortable width fixed></el-table-column>
            <el-table-column prop="SpendAmount" label="满金额" width sortable></el-table-column>
            <el-table-column prop="GetOffAmount" label="减金额" width sortable></el-table-column>
            <el-table-column label="状态" width="100" sortable>
                <template scope="scope">
                    <span v-if="scope.row.Status==0">未使用</span>
                    <span v-if="scope.row.Status==1">已使用</span>
                    <span v-if="scope.row.Status==2">已过期</span>
                </template>
            </el-table-column>
            <el-table-column prop="UseTime" label="使用日期" :formatter="formatUseTime" width="120" sortable></el-table-column>
            <el-table-column prop="OrderId" label="订单号" width sortable></el-table-column>
            <el-table-column prop="CreationTime" label="领取日期" :formatter="formatCreateTime" width="120" sortable></el-table-column>
            <el-table-column prop="ValidityEndTime" label="截止日期" :formatter="formatValidityEndTime" width="120" sortable></el-table-column>
            <!--<el-table-column prop="Creatior" label="添加人" width="100" sortable></el-table-column>-->
            <el-table-column label="操作" width="100">
                <template scope="scope">
                    <!--<el-button size="small" @click="handleEdit(scope.$index, scope.row)" v-if="isEdit">编辑</el-button>-->
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)" v-if="isDelete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
            <el-pagination layout="prev, pager, next"
                           @current-change="handleCurrentChange"
                           :page-size="50"
                           :total="total"
                           style="float:right;"></el-pagination>
        </el-col>
        <!--编辑界面-->
        <!--<el-dialog title="编辑"
                   :visible.sync="editFormVisible"
                   v-model="editFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editForm" label-width="180px" :rules="editFormRules" ref="editForm">

                <el-form-item label="名称" prop="Name">
                    <el-input v-model="editForm.Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="序号" prop="OrderNumber">
                    <el-input-number v-model="editForm.OrderNumber" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="说明" prop="Remark">
                    <el-input type="textarea" placeholder="说明" v-model="editForm.Remark"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="Status">
                    <el-radio-group v-model="editForm.Status">
                        <el-radio class="radio" :label="0">开启</el-radio>
                        <el-radio class="radio" :label="1">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>-->
        <!--新增界面-->
        <!--<el-dialog title="新增"
                   :visible.sync="addFormVisible"
                   v-model="addFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="addForm"
                     label-width="100px"
                     :rules="addFormRules"
                     ref="addForm">
                <el-form-item label="名称" prop="Name">
                    <el-input v-model="addForm.Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="序号" prop="OrderNumber">
                    <el-input-number v-model="addForm.OrderNumber" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="说明" prop="Remark">
                    <el-input type="textarea" placeholder="说明" v-model="addForm.Remark"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="Status">
                    <el-radio-group v-model="addForm.Status">
                        <el-radio class="radio" :label="0">开启</el-radio>
                        <el-radio class="radio" :label="1">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="addSubmit"
                           :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>-->

    </section>
</template>

<script>
    import util from "../../../util/date";
    import { getPageUserCoupon, removeUserCoupon, getAllCoupon } from "../../api/api";
    import { getButtonList } from "../../promissionRouter";
    /* import Toolbar from "../../components/Toolbar2";*/
    /* import global_ from '../../components/Global'//引用全局模块*/

    export default {
        /*  components: { Toolbar },*/
        data() {
            return {
                filters: {
                    name: ""
                },
                searchVal: "",
                SelUserName: "",
                SelCouponId: 0,
                SelStatus: "-1",
                couponList: [],
                buttonList: [],
                datas: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [], //列表选中列
                currentRow: null,
                //addDialogFormVisible: false,
                //editFormVisible: false, //编辑界面是否显示
                //editLoading: false,
                //editFormRules: {
                //    Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
                //    Remark: [{ required: true, message: "请输入说明", trigger: "blur" }],
                //    Status: [{ required: true, message: "请选择状态", trigger: "blur" }]
                //},
                ////编辑界面数据
                //editForm: {
                //    Id: 0,
                //    Name: '',
                //    OrderNumber: 0,
                //    Remark: '',
                //    Status: 0
                //},

                //addFormVisible: false, //新增界面是否显示
                //addLoading: false,
                //addFormRules: {
                //    Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
                //    Remark: [{ required: true, message: "请输入说明", trigger: "blur" }],
                //    Status: [{ required: true, message: "请选择状态", trigger: "blur" }]
                //},
                ////新增界面数据
                //addForm: {
                //    Id: 0,
                //    Name: '',
                //    OrderNumber: 0,
                //    Remark: '',
                //    Status: 0
                //},

                isEdit: false,
                isDelete: false,
                isAdd: false,
                isGetAllCoupon: false,
            };
        },
        filters: {
            filterDate: function (value) {
                return !value || value == ""
                    ? ""
                    : util.formatDate.format(new Date(value), "yyyy-MM-dd");
            }
        },
        methods: {
            indexMethod(index) {
                index = (index + 1) + (this.page - 1) * 20;
                //index = this.total - (this.page - 1) * 20 - index
                return index;
            },
            selectCurrentRow(val) {
                this.currentRow = val;
            },
            callFunction(item) {
                this.filters = {
                    name: item.search
                };
                this[item.Func].apply(this, item);
            },
            formatCreateTime: function (row, column) {
                return !row.CreationTime || row.CreationTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.CreationTime), "yyyy-MM-dd hh:mm");
            },
            formatUseTime: function (row, column) {
                return !row.UseTime || row.UseTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.UseTime), "yyyy-MM-dd hh:mm");
            },
            formatValidityEndTime: function (row, column) {
                return !row.ValidityEndTime || row.ValidityEndTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.ValidityEndTime), "yyyy-MM-dd");
            },
            handleCurrentChange(val) {
                this.page = val;
                this.handleQuery();
            },
            handleSearch() {
                this.page = 1;
                this.handleQuery();
            },
            //获取用户列表
            handleQuery() {
                var userId = "0";
                if (this.SelUserName == null || this.SelUserName == "" || isNaN(this.SelUserName) || Number(this.SelUserName) < 0) {
                    userId = "0";
                } else {
                    userId = this.SelUserName;
                }
                //let _this = this;
                let para = {
                    page: this.page,
                    key: this.searchVal,
                    UserId: userId,
                    CouponId: this.SelCouponId,
                    Status: this.SelStatus
                };
                this.listLoading = true;
                //NProgress.start();
                getPageUserCoupon(para).then(res => {
                    this.total = res.data.response.dataCount;
                    this.datas = res.data.response.data;
                    this.listLoading = false;

                    console.log("total=" + this.total);

                    //NProgress.done();
                });
            },
            ////删除
            handleDel(index, cRow) {
                this.currentRow = cRow;
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error"
                    });

                    return;
                }
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        this.listLoading = true;
                        //NProgress.start();
                        let para = { id: row.Id };
                        removeUserCoupon(para).then(res => {
                            if (util.isEmt.format(res)) {
                                this.listLoading = false;
                                return;
                            }
                            this.listLoading = false;
                            //NProgress.done();
                            if (res.data.success) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error"
                                });
                            }

                            this.handleQuery();
                        });
                    })
                    .catch(() => { });
            },
            ////显示编辑界面
            //handleEdit(index, cRow) {

            //    this.baseInfos = [];

            //    this.currentRow = cRow;
            //    let row = this.currentRow;
            //    if (!row) {
            //        this.$message({
            //            message: "请选择要编辑的一行数据！",
            //            type: "error"
            //        });
            //        return;
            //    }

            //    let that = this;

            //    this.editForm = {};
            //    that.editLoading = true;
            //    that.editFormVisible = true;

            //    that.editForm = Object.assign({}, row);

            //    that.editLoading = false;

            //},
            ////显示新增界面
            //handleAdd() {
            //    this.addFormVisible = true;
            //    this.addLoading = true;
            //    this.addForm = {
            //        Name: '',
            //        OrderNumber: 0,
            //        Remark: '',
            //        Status: 0
            //    };
            //    this.addLoading = false;
            //},
            ////编辑
            //editSubmit: function () {
            //    this.$refs.editForm.validate(valid => {
            //        if (valid) {
            //            this.$confirm("确认提交吗？", "提示", {}).then(() => {
            //                this.editLoading = true;
            //                //NProgress.start();

            //                let para = Object.assign({}, this.editForm);
            //                if (para.Name == null || para.Name == "") {
            //                    this.$message({
            //                        message: "名称不能为空！",
            //                        type: "error"
            //                    });
            //                    this.editLoading = false;
            //                    return;
            //                }

            //                if (para.Remark == null || para.Remark == "") {
            //                    this.$message({
            //                        message: "说明不能为空！",
            //                        type: "error"
            //                    });
            //                    this.editLoading = false;
            //                    return;
            //                }

            //                editGoodsName(para).then(res => {
            //                    if (util.isEmt.format(res)) {
            //                        this.editLoading = false;
            //                        return;
            //                    }

            //                    if (res.data.success) {
            //                        this.editLoading = false;
            //                        //NProgress.done();
            //                        this.$message({
            //                            message: res.data.msg,
            //                            type: "success"
            //                        });
            //                        this.$refs["editForm"].resetFields();
            //                        this.editFormVisible = false;
            //                        this.handleQuery();
            //                    } else {
            //                        this.$message({
            //                            message: res.data.msg,
            //                            type: "error"
            //                        });
            //                        this.editLoading = false;
            //                    }
            //                });
            //            });
            //        }
            //    });
            //},
            ////新增
            //addSubmit: function () {
            //    let _this = this;
            //    this.$refs.addForm.validate(valid => {
            //        if (valid) {
            //            this.$confirm("确认提交吗？", "提示", {}).then(() => {
            //                this.addLoading = true;
            //                //NProgress.start();
            //                let para = Object.assign({}, this.addForm);


            //                if (para.Name == null || para.Name == "") {
            //                    this.$message({
            //                        message: "名称不能为空！",
            //                        type: "error"
            //                    });
            //                    this.addLoading = false;
            //                    return;
            //                }

            //                if (para.Remark == null || para.Remark == "") {
            //                    this.$message({
            //                        message: "说明不能为空！",
            //                        type: "error"
            //                    });
            //                    this.addLoading = false;
            //                    return;
            //                }
            //                addGoodsName(para).then(res => {
            //                    if (util.isEmt.format(res)) {
            //                        this.addLoading = false;
            //                        return;
            //                    }
            //                    if (res.data.success) {
            //                        this.addLoading = false;
            //                        //NProgress.done();
            //                        this.$message({
            //                            message: res.data.msg,
            //                            type: "success"
            //                        });
            //                        this.$refs["addForm"].resetFields();
            //                        this.addFormVisible = false;
            //                        this.isCarNoShow = true;
            //                        this.handleQuery();
            //                    } else {
            //                        this.$message({
            //                            message: res.data.msg,
            //                            type: "error"
            //                        });
            //                        this.addLoading = false;
            //                    }

            //                });
            //            });
            //        }
            //    });
            //},
            selsChange: function (sels) {
                this.sels = sels;
            },
            ////批量删除
            //batchRemove: function () {
            //    this.$message({
            //        message: "该功能未开放",
            //        type: "warning"
            //    });
            //},
            //getButtonList2(routers) {
            //    let _this = this;
            //    routers.forEach(element => {
            //        let path = this.$route.path.toLowerCase();
            //        if (element.path && element.path.toLowerCase() == path) {
            //            _this.buttonList = element.children;
            //            return;
            //        } else if (element.children) {
            //            _this.getButtonList(element.children);
            //        }
            //    });
            //}
            //获取价格类型
            getAllCouponList() {
                //let _this = this;
                let para = {
                };
                this.listLoading = true;
                //NProgress.start();
                getAllCoupon(para).then(res => {
                    console.log(res);
                    this.couponList = res.data.response;
                    this.listLoading = false;

                    //console.log("total=" + this.total);

                    //NProgress.done();
                });
            },
        },
        mounted() {

            var queryUserId = this.$route.query.UserId;//获取从会员管理查询点击定位跳转过来的会员Id
            if (queryUserId && queryUserId != null && queryUserId != "" && !isNaN(queryUserId) && Number(queryUserId) > 0) {
                this.SelUserName = queryUserId.toString();
            }

            this.getAllCouponList();
            this.handleQuery();

            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            //第一种写法，每个页面都需要写方法，但是可以做特性化处理
            // this.getButtonList(routers);

            //第二种写法，封装到 permissionRouter.js 中
            this.buttonList = getButtonList(this.$route.path, routers);

            this.buttonList.forEach(item => {
                if (item.Func == "handleEdit") {
                    this.isEdit = true;
                }
                else if (item.Func == "handleDel") {
                    this.isDelete = true;
                }
                else if (item.Func == "handleAdd") {
                    this.isAdd = true;
                }
                else if (item.Func == "handleGetAllCoupon") {
                    this.isGetAllCoupon = true;
                }
                //else if (item.Func == "handleExport") {
                //    this.isExport = true;
                //}
                //
            });
        }
    };
</script>

<style scoped>
</style>
